import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_3 = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center lg:p-0" }
const _hoisted_4 = { class: "py-4 px-5 md:px-6 border-b flex justify-between items-center flex-wrap" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-lg md:text-2xl font-medium text-gray-900" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "flex justify-end items-center" }
const _hoisted_10 = { class: "divide-y" }
const _hoisted_11 = { class: "w-1/3 pr-10" }
const _hoisted_12 = { class: "text-lg leading-6 font-medium" }
const _hoisted_13 = { class: "text-sm leading-5 font-normal text-gray-500 mt-1" }
const _hoisted_14 = { class: "w-2/3 pl-10" }
const _hoisted_15 = { class: "flex flex-wrap" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 1,
  class: "py-2 px-4 rounded-md mr-2 mb-2 text-sm bg-gray-200 text-gray-500"
}
const _hoisted_18 = {
  key: 0,
  class: "py-2 px-4 rounded-md mr-2 mb-2 text-sm bg-gray-200 text-gray-500"
}
const _hoisted_19 = {
  key: 1,
  class: "py-2 px-4 rounded-md mr-2 mb-2 text-sm bg-blue-200 text-sky"
}
const _hoisted_20 = {
  key: 2,
  class: "py-2 px-4 rounded-md mr-2 mb-2 text-sm bg-blue-200 text-sky"
}
const _hoisted_21 = {
  key: 1,
  class: "py-2 px-4 rounded-md mr-2 mb-2 text-sm bg-gray-200 text-gray-500"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 1,
  class: "py-2 px-4 rounded-md mr-2 mb-2 text-sm bg-gray-200 text-gray-500"
}
const _hoisted_24 = { class: "px-5 md:px-6 py-6 mt-6 border-t" }
const _hoisted_25 = { class: "w-full" }
const _hoisted_26 = { class: "flex justify-between items-center mb-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg leading-6 font-medium" }, " Originators ", -1)
const _hoisted_28 = {
  key: 0,
  class: "flex items-center justify-start"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal" }, "There are no originators yet", -1)
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "flex items-center space-x-3" }
const _hoisted_32 = { class: "text-gray-500" }
const _hoisted_33 = { class: "text-gray-500 text-sm" }
const _hoisted_34 = { class: "flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PencilIcon = _resolveComponent("PencilIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_UserAddIcon = _resolveComponent("UserAddIcon")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_ShieldCheckIcon = _resolveComponent("ShieldCheckIcon")!
  const _component_base_rating = _resolveComponent("base-rating")!
  const _component_BanIcon = _resolveComponent("BanIcon")!
  const _component_data_table = _resolveComponent("data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "fixed z-10 inset-0 overflow-y-auto",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeModal('ModalLender')))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-8 max-w-4xl w-full",
          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.localLender.logoUri)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.localLender.logoUri,
                    class: "max-h-6 max-w-6 mr-2"
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.localLender.name), 1),
                (_ctx.localLender.lenderUri)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.localLender.lenderUri,
                      target: "_blank",
                      class: "text-blue-500"
                    }, _toDisplayString(_ctx.localLender.lenderUri), 9, _hoisted_8))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "bg-sky text-white rounded-md text-sm px-3 py-1.5 flex items-center",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal('ModalNewLender', { lender: _ctx.localLender, editor: true })))
              }, [
                _createVNode(_component_PencilIcon, { class: "w-3 h-3 mr-2" }),
                _createTextVNode(" Edit lender ")
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "border border-gray-400 bg-white rounded-md text-gray-500 hover:text-gray-800 focus:outline-none p-2 bg-gray-100 ml-4",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal('ModalLender')))
              }, [
                _createVNode(_component_XIcon, { class: "w-5 h-5" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, ({ title, subtitle, model, items }, category) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex p-6",
                key: category
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h4", _hoisted_12, _toDisplayString(title), 1),
                  _createElementVNode("p", _hoisted_13, _toDisplayString(subtitle), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    (model == 'description')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.localLender.description)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                innerHTML: _ctx.parseMarkdown(_ctx.localLender.description),
                                class: "markdown-box w-full font-normal text-sm"
                              }, null, 8, _hoisted_16))
                            : (_openBlock(), _createElementBlock("div", _hoisted_17, " No data "))
                        ], 64))
                      : (model == 'amountRange')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (!_ctx.localLender?.creditBox?.minimumAmount && !_ctx.localLender?.creditBox?.maximumAmount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, " No data "))
                              : _createCommentVNode("", true),
                            (_ctx.localLender?.creditBox?.minimumAmount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, " From $" + _toDisplayString(_ctx.convertToShortCurrency(_ctx.localLender.creditBox?.minimumAmount)), 1))
                              : _createCommentVNode("", true),
                            (_ctx.localLender.creditBox?.maximumAmount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, " To $" + _toDisplayString(_ctx.convertToShortCurrency(_ctx.localLender.creditBox?.maximumAmount)), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (model == 'firmTypes')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              (_ctx.localLender.firmTypes.length)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getTags(_ctx.localLender.firmTypes, items, 'id'), (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["py-2 px-4 rounded-md mr-2 mb-2 text-sm bg-blue-200 text-sky", { 'cursor-pointer': index == items - 1 }]),
                                      key: index
                                    }, _toDisplayString(_ctx.typeNamesMap[item] || item), 3))
                                  }), 128))
                                : (_openBlock(), _createElementBlock("div", _hoisted_21, " No data "))
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (_ctx.localLender.creditBox[model]?.length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localLender.creditBox[model].filter((item, index) => index < items), (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "py-2 px-4 rounded-md mr-2 mb-2 text-sm bg-blue-200 text-sky",
                                        key: index
                                      }, _toDisplayString(_ctx.typeNamesMap[item] || item), 1))
                                    }), 128)),
                                    (_ctx.localLender.creditBox[model].length > items)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "py-2 px-4 rounded-md mr-2 mb-2 text-sm bg-blue-200 text-sky cursor-pointer",
                                          onClick: ($event: any) => (_ctx.categories[category].items = 1000)
                                        }, " + " + _toDisplayString(_ctx.localLender.creditBox[model].length - items), 9, _hoisted_22))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createElementBlock("div", _hoisted_23, " No data "))
                            ], 64))
                  ])
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                (_ctx.originators.length)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "px-3 py-1 bg-indigo-500 hover:bg-sky text-white hover:text-white text-xs rounded-full flex items-center",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal('ModalNewOriginator', { lender: _ctx.localLender })))
                    }, [
                      _createVNode(_component_UserAddIcon, { class: "w-3 h-3 mr-1.5" }),
                      _createTextVNode(" Add ")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_base_spinner, {
                    key: 0,
                    class: "border py-10 rounded-md"
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (!_ctx.originators.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("button", {
                            type: "button",
                            class: "ml-3 bg-sky text-white rounded-md text-xs py-1 px-2",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal('ModalNewOriginator', { lender: _ctx.localLender })))
                          }, " Create one ")
                        ]))
                      : (_openBlock(), _createBlock(_component_data_table, {
                          key: 1,
                          tableData: _ctx.originators,
                          tableHeader: _ctx.tableHeader,
                          class: "border rounded-md"
                        }, {
                          "cell-name": _withCtx(({ row: originator }) => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["font-medium text-gray-900 cursor-pointer", { 'opacity-50': originator.deleted }]),
                              onClick: ($event: any) => (_ctx.showModal('ModalOriginator', { originator }))
                            }, _toDisplayString(originator.name), 11, _hoisted_30)
                          ]),
                          "cell-overview": _withCtx(({ row: match }) => [
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_ShieldCheckIcon, {
                                class: _normalizeClass(["w-4 h-4", {
                          'text-blue-500': match.isVerified,
                          'text-gray-300': !match.isVerified
                        }])
                              }, null, 8, ["class"]),
                              (match.rating)
                                ? (_openBlock(), _createBlock(_component_base_rating, {
                                    key: 0,
                                    rating: match.rating
                                  }, null, 8, ["rating"]))
                                : _createCommentVNode("", true),
                              (match.deleted)
                                ? (_openBlock(), _createBlock(_component_BanIcon, {
                                    key: 1,
                                    class: "w-4 h-4 text-red-700",
                                    alt: "Soft deleted"
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          "cell-location": _withCtx(({ row: originator }) => [
                            _createElementVNode("span", _hoisted_32, _toDisplayString(originator.city || '–') + ", " + _toDisplayString(originator.stateProvince || '–'), 1)
                          ]),
                          "cell-activity": _withCtx(({ row: originator }) => [
                            _createElementVNode("span", _hoisted_33, _toDisplayString(originator.lastLogin ? `Last login ${_ctx.moment(originator.lastLogin)}` : 'N/a'), 1)
                          ]),
                          "cell-products": _withCtx(({ row: originator }) => [
                            _createElementVNode("div", _hoisted_34, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(originator.creditBoxes), (product, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: index,
                                  class: "py-1 px-2.5 rounded-full mr-2 text-xs bg-blue-200 text-sky"
                                }, _toDisplayString(product), 1))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }, 8, ["tableData", "tableHeader"]))
                  ], 64))
            ])
          ])
        ])
      ])
    ])
  ]))
}